var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.company && _vm.office)?_c('company-edit',_vm._g(_vm._b({},'company-edit',{ company: _vm.company, office: _vm.office, tasktypes: _vm.tasktypes },false),{ ok: _vm.ok, cancel: _vm.cancel, remove: _vm.remove })):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }